<template>
    <div>
        <div class="col-12 form-group">
            <label for="type">Type</label>
            <v-select
                v-model="question.type"
                :options="types"
                :clearable="false"
                label="text"
                :reduce="option => option.value"
                :disabled="!!question.id"
                @input="emitQuestion"
            />
        </div>
        <div class="form-group col-12">
            <label>Required</label>
            <b-form-checkbox
                v-model="question.isRequired"
                switch
                @input="emitQuestion"
            />
        </div>
        <div class="form-group col-12 col-md-6">
            <label for="label">
                Label
            </label>
            <input
                id="label"
                v-model="question.label"
                type="text"
                class="form-control"
                :class="{
                    'is-invalid': hasError('label')
                }"
                dir="auto"
                @blur="emitQuestion"
            />
            <div class="invalid-feedback">
                {{ getError('label') }}
            </div>
        </div>
        <div class="form-group col-12 col-md-6">
            <label for="placeholder">
                Placeholder
            </label>
            <input
                id="placeholder"
                v-model="question.placeholder"
                type="text"
                class="form-control"
                dir="auto"
                :disabled="!isPlaceholderAllowed"
                @blur="emitQuestion"
            />
        </div>
        <div class="form-group col-12 col-md-6">
            <label for="width">
                Width [%]
            </label>
            <input
                id="width"
                v-model="question.width"
                type="number"
                class="form-control"
                :class="{
                    'is-invalid': hasError('width')
                }"
                @blur="emitQuestion"
            />
            <div class="invalid-feedback">
                {{ getError('width') }}
            </div>
        </div>
        <div class="form-group col-12 col-md-6">
            <label for="regex">
                Regex
            </label>
            <input
                id="regex"
                v-model="question.regex"
                type="text"
                class="form-control"
                dir="auto"
                :disabled="!isRegexAllowed"
                @blur="emitQuestion"
            />
        </div>

        <settings
            v-if="areSettingsAvailable"
            v-model="question.settings"
            class="col-12"
            :type="question.type"
            @input="emitQuestion"
        />

        <hr />

        <div class="col-12 form-group row justify-content-end">
            <button class="btn btn-success" @click="$emit('save')">
                Save question
            </button>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Settings from './Settings';

export default {
    components: {
        Settings
    },

    props: {
        value: {
            type: Object,
            required: true
        },
        validation: {
            type: Object,
            required: true
        },
        serverErrors: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            question: {}
        };
    },

    computed: {
        ...mapGetters({
            types: 'questions/types',
            shortType: 'questions/SHORT',
            longType: 'questions/LONG',
            numberType: 'questions/NUMBER',
            emailType: 'questions/EMAIL',
            dropdownType: 'questions/DROPDOWN',
            multiSelectType: 'questions/MULTI_SELECT'
        }),

        isPlaceholderAllowed() {
            return [
                this.shortType,
                this.longType,
                this.numberType,
                this.emailType
            ].includes(this.question.type);
        },

        isRegexAllowed() {
            return [this.shortType, this.longType, this.numberType].includes(
                this.question.type
            );
        },

        areSettingsAvailable() {
            return [this.dropdownType, this.multiSelectType].includes(
                this.question.type
            );
        }
    },

    watch: {
        isRegexAllowed(val) {
            if (!val) {
                this.question.regex = null;
            }
        },

        isPlaceholderAllowed(val) {
            if (!val) {
                this.question.placeholder = null;
            }
        },

        areSettingsAvailable(val) {
            if (!val) {
                this.question.settings = {};
            }
        }
    },

    created() {
        this.question = { ...this.value };
    },

    methods: {
        hasError(key) {
            return (
                this.validation[key].$error ||
                this.serverErrors.find(error => error.param === key)
            );
        },

        getError(key) {
            return this.$getValidationErrorMessageHandler.handle(
                this.validation,
                this.serverErrors,
                key
            );
        },

        emitQuestion() {
            this.$emit('input', this.question);
        }
    }
};
</script>
